export default function () {
  const widgetName = 'hotButtons';
  const widgetOpts = hotButtonsOpts;
  const $widget = $(`#${widgetName}`);
  $widget.wrap(`<div class="tier-2-container"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    maxItemsVisible: 4,
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    moreButton: false,
    buyNowButton: false,
    showDescription: false,
    textOverImage: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $('.tier-2-container').remove();
      } else {
        createCustomButtons(data.items);
      }
    },
  });

  function createCustomButtons(items) {
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { Title, URL } = items[x];
      const $card = $(this);
      $card.text(Title).find('.card-content').remove();

      if (!URL) {
        $card.removeAttr('href');
      }
    });
  }
}
